var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaqIcon = function SvgFaqIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#FaqIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.833,
    d: "M8.333 8.25a2.767 2.767 0 1 1 5.28 1.66c0 1.832-2.613 1.87-2.613 1.87m0 3.803h.01M20.166 11a9.167 9.167 0 1 1-18.334 0 9.167 9.167 0 0 1 18.334 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "FaqIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export { SvgFaqIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/FaqIcon.d4e7a715.svg";